import { useNavigate } from "react-router-dom";
import { DEV_USERS, SHOW_DEV_LOGINS, useAuth } from "../auth/AuthProvider.tsx";
import { isSupabaseConfigured } from "../lib/supabase.ts";

/** Dev login buttons — visible only in test/local mode (§13.2). */
export function DevLogins() {
  const auth = useAuth();
  const navigate = useNavigate();
  if (!SHOW_DEV_LOGINS || !isSupabaseConfigured()) return null;
  return (
    <div className="mt-2 rounded-lg border border-dashed border-border-strong p-3">
      <p className="mb-2 text-[11px] uppercase tracking-wide text-ink-400">Dev logins</p>
      <div className="flex flex-wrap gap-2">
        {DEV_USERS.map((u) => (
          <button
            key={u.key}
            type="button"
            data-testid={`action-devlogin-${u.key}`}
            className="btn-ghost px-3 py-1.5 text-sm"
            onClick={async () => {
              try {
                await auth.signInAsDev(u.key);
                navigate("/auth/callback");
              } catch {
                /* surfaced elsewhere */
              }
            }}
          >
            {u.label}
          </button>
        ))}
      </div>
    </div>
  );
}
